import { useMutation } from '@tanstack/react-query';
import { csvErrorsFromRequestError, PriceListCsvError } from '../errors';
import { usePriceListsApi } from './use-price-lists-api';

export function useUploadCsv() {
  const { priceListsApi } = usePriceListsApi();

  async function uploadCsv({ slug, file }: { slug: string; file: File }) {
    try {
      await priceListsApi.priceList(slug).uploadCsv(await file.text());
    } catch (err) {
      throw new PriceListCsvError(csvErrorsFromRequestError(err));
    }
  }

  return useMutation({
    mutationFn: uploadCsv,
  });
}
